function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_Iconography_360",
  "data-name": "[Iconography] 360",
  transform: "translate(0.75)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_669",
  "data-name": "Path 669",
  d: "M57.556,54.488c13.6-.752,23.828-3.987,23.828-7.864,0-2.626-4.693-4.957-11.947-6.422",
  transform: "translate(-21.626 -31.39)",
  fill: "none",
  stroke: "#01174f",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_670",
  "data-name": "Path 670",
  d: "M23.809,40.2c-7.254,1.465-11.948,3.8-11.948,6.422,0,3.877,10.228,7.112,23.829,7.864",
  transform: "translate(-11.861 -31.39)",
  fill: "none",
  stroke: "#01174f",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_671",
  "data-name": "Path 671",
  d: "M39.745,61.362l3.468,4.67L38.543,69.5",
  transform: "translate(-18.562 -42.913)",
  fill: "none",
  stroke: "#01174f",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_661",
  "data-name": "Group 661",
  transform: "translate(-941.799 -400.111)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_657",
  "data-name": "Group 657",
  transform: "translate(958.27 402.273)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_665",
  "data-name": "Path 665",
  d: "M958.693,418.933a3.345,3.345,0,0,1,3.492-3.281,3.056,3.056,0,0,1,3.281,3.22,2.828,2.828,0,0,1-1.089,2.374,2.977,2.977,0,0,1,1.466,2.782,3.529,3.529,0,0,1-3.795,3.629,3.735,3.735,0,0,1-3.78-3.6h2.237a1.633,1.633,0,0,0,1.633,1.663,1.843,1.843,0,0,0-.075-3.644l-.408.03V420.52h.242a1.386,1.386,0,0,0,1.452-1.572,1.337,1.337,0,0,0-1.3-1.451,1.361,1.361,0,0,0-1.24,1.436Z",
  transform: "translate(-958.27 -415.486)",
  fill: "#01174f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_666",
  "data-name": "Path 666",
  d: "M1021.64,415.721l-2.344,3.311.03.03a2.4,2.4,0,0,1,.892-.151,3.533,3.533,0,0,1,3.387,3.78,3.875,3.875,0,0,1-4.022,4.022,3.814,3.814,0,0,1-3.991-3.87,7.141,7.141,0,0,1,1.391-3.81l3.024-4.49Zm-.272,7.061a1.829,1.829,0,1,0-1.8,2.117A1.993,1.993,0,0,0,1021.367,422.782Z",
  transform: "translate(-1007.005 -414.542)",
  fill: "#01174f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_667",
  "data-name": "Path 667",
  d: "M1081.887,421.669c0,2.434-1.058,5.987-4.082,5.987s-4.082-3.553-4.082-5.987c0-2.449,1.028-6.017,4.082-6.017S1081.887,419.22,1081.887,421.669Zm-5.987-.03c0,1.134.333,4.082,1.905,4.082s1.905-2.948,1.905-4.082c0-1.149-.318-4.052-1.905-4.052S1075.9,420.49,1075.9,421.639Z",
  transform: "translate(-1056.427 -415.486)",
  fill: "#01174f"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_658",
  "data-name": "Group 658",
  transform: "translate(982.798 400.111)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_668",
  "data-name": "Path 668",
  d: "M1124.28,404.672a2.28,2.28,0,1,1,2.28-2.281A2.283,2.283,0,0,1,1124.28,404.672Zm0-3.063a.782.782,0,1,0,.782.782A.783.783,0,0,0,1124.28,401.609Z",
  transform: "translate(-1122 -400.111)",
  fill: "#01174f"
}))));

var SvgIconRotate360 = function SvgIconRotate360(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61.259,
    height: 27.637,
    viewBox: "0 0 61.259 27.637",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRotate360, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconRotate360.6c670bef.svg";
export { ForwardRef as ReactComponent };